const namespace = 'main-data';
export default namespace;
